/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InPageAlert = function () {
  function InPageAlert() {
    _classCallCheck(this, InPageAlert);
    this.inPageAlertComponent = document.querySelector('.paragraph--type--in-page-alert');
    if (this.inPageAlertComponent) {
      this.alertButton = this.inPageAlertComponent.querySelector('.mobile-collapse-expand');
    }
  }
  return _createClass(InPageAlert, [{
    key: "setClickHandlers",
    value: function setClickHandlers() {
      var _this = this;
      if (this.alertButton) {
        this.alertButton.addEventListener('click', function () {
          InPageAlert.toggleIcon(_this.alertButton);
          InPageAlert.toggleAlertOpenClosed(_this.alertButton);
        });
      }
    }
  }], [{
    key: "toggleIcon",
    value: function toggleIcon(alertButton) {
      alertButton.querySelector('.alert-collapse-expand-icon-expand').classList.toggle('hidden');
      alertButton.querySelector('.alert-collapse-expand-icon-collapse').classList.toggle('hidden');
    }
  }, {
    key: "toggleAlertOpenClosed",
    value: function toggleAlertOpenClosed(alertButton) {
      alertButton.closest('.paragraph--type--in-page-alert').classList.toggle('collapsed');
    }
  }]);
}();
export { InPageAlert as default };
(function () {
  var inPageAlert = new InPageAlert();
  inPageAlert.setClickHandlers();
})(Drupal);